import { Component } from 'preact'
import { SketchPicker } from 'react-color'

class IdeationAddColor extends Component {
  constructor () {
    super()
    this.state = {
      enablePicker: false
    }
    this.bodyClickHandler = this.bodyClickHandler.bind(this)
    this.root = null
  }

  bodyClickHandler (e) {
    const ref = this.root
    if (!ref.contains(e.target)) {
      this.setState({ enablePicker: false })
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (nextState.enablePicker && !this.state.enablePicker) {
      document.addEventListener('click', this.bodyClickHandler)
    } else if (!nextState.enablePicker && this.state.enablePicker) {
      document.removeEventListener('click', this.bodyClickHandler)
    }
  }

  render (props, state) {
    return (
      <div className={`form-group ideation-color-add-field-container ${props.qaClasses || ''}`} data-type={props.type} ref={root => { this.root = root }} onClick={() => this.setState({ enablePicker: true })}>
        <label>{props.title}</label>
        <div className='form-group form-control ideation-color-add-container'>
          <span className='ideation-add__color-visual'>
            <span style={{ backgroundColor: props.selectedColor }} className='ideation-color-preview' />
            <span>{ props.selectedColor }</span>
          </span>
          <span className='ideation-arrow-icon'>
            <i className='icon-full-arrow-bottom' />
          </span>
          <span className='ideation-add__color-picker-container' >
            {
              state.enablePicker ? (
                <SketchPicker
                  disableAlpha
                  color={props.selectedColor}
                  presetColors={props.colors}
                  onChangeComplete={(color) => props.onCallback({ [props.type]: color.hex })}
                />
              ) : null
            }
          </span>
        </div>
      </div>
    )
  }
}

export default IdeationAddColor
